import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=7bfa26a7&scoped=true&"
import script from "./ProductDescription.vue?vue&type=script&lang=ts&"
export * from "./ProductDescription.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDescription.vue?vue&type=style&index=0&id=7bfa26a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfa26a7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsDocument24px: require('/var/www/packages/theme/components/icons/document/Document24px.vue').default,AtomsMarkdownRender: require('/var/www/packages/theme/components/atoms/MarkdownRender.vue').default,MoleculesShowMoreOverlay: require('/var/www/packages/theme/components/molecules/ShowMoreOverlay.vue').default})
